import { AlertTriangle } from 'lucide-react';

interface FormAlertProps {
  message: string;
  /** Adds a Dismiss button for alerts that would otherwise stay on screen. */
  onDismiss?: () => void;
}

/** A refusal or failure, announced to screen readers as it appears. */
export function FormAlert({ message, onDismiss }: FormAlertProps) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        gap: 8,
        alignItems: 'flex-start',
        padding: '9px 11px',
        borderRadius: 8,
        background: 'var(--nb-warn-soft)',
        borderLeft: '3px solid var(--nb-warn)',
        color: 'var(--nb-ink)',
        fontSize: 11.5,
        lineHeight: 1.45,
      }}
    >
      <AlertTriangle size={13} aria-hidden="true" style={{ flex: '0 0 auto', marginTop: 1 }} />
      <span style={{ flex: 1 }}>{message}</span>
      {onDismiss && (
        <button type="button" className="nb-link-btn" onClick={onDismiss} style={{ fontSize: 11 }}>
          Dismiss
        </button>
      )}
    </div>
  );
}
